import { Routes } from '../../helpers/auth-verify';

export default {

    path: '/cyclic-reports',
    component: () => import(/* webpackChunkName: "index" */ '@/views/index'),
    redirect: { name: Routes.TRACKS },
    children: [
        {
            path: '/',
            name: Routes.TRACKS_CONFIG,
            component: () => import(/* webpackChunkName: "Tracks" */ '@/views/cyclicRevision/Tracks.vue')
        },
        {
            path: '/sequence-evaluations',
            name: Routes.TRACKS_SEQUENCE_EVALUATIONS,
            component: () => import(/* webpackChunkName: "SequenceEvaluations" */ '@/views/cyclicRevision/SequenceEvaluations.vue')
        },
        {
            path: '/add-track',
            name: 'trackManagement',
            component: () => import(/* webpackChunkName: "TracksManagement" */ '@/views/cyclicRevision/TrackManagement.vue')
        },
        {
            path: '/edit-track/:id',
            name: 'editTrack',
            component: () => import(/* webpackChunkName: "TracksManagement" */ '@/views/cyclicRevision/TrackManagement.vue')
        }
    ]
};
